module.exports = __webpack_public_path__ + "img/20211017_092217.b1a17a55.jpg";